<div class="loader-container" [style.min-width]="size + 'px'" [style.min-height]="size + 'px'">
  <div class="squaresContainer" [style.width]="size * .6 + 'px'" [style.height]="size * .6 + 'px'">
    <div class="square1 square"></div>
    <div class="square2 square"></div>
    <div class="square4 square"></div>
    <div class="square3 square"></div>
  </div>
</div>
